import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueFormulate from '@braid/vue-formulate'
import { it } from '@braid/vue-formulate-i18n'
import axios from 'axios'
import BootstrapVue from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret, faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMeta from 'vue-meta'




library.add(faUserSecret, faChevronDown)
library.add(faFacebook, faTwitter, faYoutube, faInstagram)


Vue.use(VueFormulate,{
  plugins: [ it ],
  locale: 'it',
  uploader: axios.create({
    baseURL: 'https://dev.garage.pizza'
  }),
  uploadUrl: '/api/lievitamente/upload'
})


Vue.use(VueMeta)
Vue.use(BootstrapVue)
Vue.component('font-awesome-icon', FontAwesomeIcon);



new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js